import React from 'react';
import { useSelector } from 'react-redux';
import PaymentDetailsRow from '../payment-details-row';
import './index.scss';

const PaymentDetailsQuantityRow = ({
  value,
  error = null,
  onValueChange = () => {},
  min = 0,
  max = 0,
}) => {
  // Redux
  const translations = useSelector((store) => store.config.Translations);
  return (
    <PaymentDetailsRow
      label={translations['payment_quantity_label']}
      value={(
        <div className="payment-details-quantity-field">
          <button
            type="button"
            disabled={value === max}
            className="quantity-button quantity-button_add-button"
            onClick={() => onValueChange(value + 1)}
            title={translations['payment_add_quantity_label']}
            aria-label={translations['payment_add_quantity_label']}
          >
            <div className={'icon-vertical'}/>
            <div className={'icon-horizontal'}/>
          </button>

          <div className="quantity-value">{value}</div>

          <button
            type="button"
            disabled={value === min}
            className="quantity-button quantity-button_subtract-button"
            onClick={() => onValueChange(value - 1)}
            title={translations['payment_subtract_quantity_label']}
            aria-label={translations['payment_subtract_quantity_label']}
          >
            <div className={'icon-horizontal'} />
          </button>
        </div>
      )}
      error={error}
    />
  );
};

export default PaymentDetailsQuantityRow;
